import { mapMutations } from 'vuex';
export default {
    methods: {
        ...mapMutations('favorites', ['initFavProducts']),
        ...mapMutations('compare', ['initCompareProducts']),
        ...mapMutations('cart', ['initCartStore']),
        async stockCheckHandler(cart) {
            const getIds = cart?.products?.map(item => item?.product?.productId);
            let notFoundProducts = [];
            if (getIds?.length) {
                const { data } = await this.$store.dispatch('cart/getProductsStockStatus', getIds);
                notFoundProducts = data;
            } else {
                this.initCartStore([]);
                return;
            }

            const notFoundProductIds = Object.entries(notFoundProducts)
                .filter(([productId, status]) => status === 'not_found')
                .map(([productId]) => parseInt(productId));
            if (process.client) {
                const favorites = localStorage?.getItem('favorites');
                const compare = localStorage?.getItem('compare');

                if (notFoundProductIds && favorites) {
                    let updatedFavorites = JSON.parse(favorites)?.filter(
                        product => !notFoundProductIds.includes(product?.productId)
                    );

                    this.initFavProducts(updatedFavorites);
                    localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
                    this.$cookies.set('favorites', JSON.stringify(updatedFavorites));
                }

                if (notFoundProductIds && compare) {
                    let updatedCompare = JSON.parse(compare)?.filter(product => !notFoundProductIds.includes(product?.productId));

                    this.initCompareProducts(updatedCompare);
                    localStorage.setItem('compare', JSON.stringify(updatedCompare));
                }

                // Update the cart in localStorage
                localStorage.setItem('cart', JSON.stringify(cart));
            }

            // Remove not-found products from the cart
            const updatedProducts = cart?.products?.filter(product => !notFoundProductIds.includes(product.product?.productId));

            cart.products = updatedProducts;

            // Update the cart store
            this.initCartStore(cart);
        },
    },
};
